import Message from '../../Messages';
import { useMemo  } from 'react';
import { withStyles } from '@material-ui/core/styles';
import styles from '../../chatStyle';
import { getDispatcherName } from '../../utils';

const RenderMessageStartDate = ({ classes, date, terminalCodes="" }) => {
  return (
    <div className={classes.groupedMessageContainer}>
      <span className={classes.groupedMessageLabel}>{`${date}, ${terminalCodes}`}</span>
    </div>
  );
};

const Messages = ({ messageHistory, driverInfo, terminalOffset, classes }) => {
  const memoizedComponent = useMemo(() => {
    return (
      <div className={classes.messageHistoryContainer}>
        {messageHistory.map((group) => [
          <RenderMessageStartDate
            classes={classes}
            date={group.date}
            terminalCodes={group.terminalCodes}
            key={group.date}
          />,
          ...group.messages.map((message) => (
            <Message
              classes={classes}
              message={message}
              key={message.messageId}
              driverName={driverInfo.name}
              dispatcherName={getDispatcherName(message)}
              terminalOffset={terminalOffset}
              isMessageHistoryFlow
            />
          ))
        ])}
      </div>
    );
  }, [messageHistory]);
  return memoizedComponent;
};

export default withStyles(styles)(Messages);
